// extracted by mini-css-extract-plugin
module.exports = {"inputs":"style__inputs__derAy"};